

























































































import { AxiosInstance } from 'axios'

export default {
  data() {
    return {
      email: '',
      isSubmitted: false,
      isError: false,
      errorMsg: '',
    }
  },
  methods: {
    resendConfirmation() {
      const http: AxiosInstance = this.$store.getters.http
      http
        .post('/api/auth/users/resend_confirmation', {
          email: this.email,
          language: this.$i18n.locale,
        })
        .then(response => {
          const data = response.data
          if (data.ok) {
            this.isSubmitted = true
          } else {
            this.isSubmitted = false
            this.errorMsg = data.error
          }
        })
        .catch(e => {
          this.isError = true
        })
    },
    retry() {
      this.isSubmitted = false
      this.isError = false
    },
  },
}
